import { StateCode } from '../../../components/ssap/SsapTypes';

export const showQualifyhardshipQTooltip = [StateCode.PENNSYLVANIA, StateCode.VIRGINIA];
export const defaultHardshipTableVisibility  = [
  StateCode.GEORGIA,
  StateCode.IDAHO,
  StateCode.MINNESOTA,
  StateCode.NEW_MEXICO,
  StateCode.NEVADA,
  StateCode.PENNSYLVANIA,
  StateCode.VIRGINIA
];
export const seekingCoverageEnabledStates = [
  StateCode.GEORGIA,
  StateCode.NEW_JERSEY,
  StateCode.NEW_MEXICO,
  StateCode.NEVADA,
  StateCode.PENNSYLVANIA,
  StateCode.VIRGINIA
];
export const householdMembersTooltipEnablesStates = [
  StateCode.GEORGIA,
  StateCode.NEW_JERSEY,
  StateCode.NEW_MEXICO,
  StateCode.NEVADA,
  StateCode.PENNSYLVANIA,
  StateCode.VIRGINIA
];
export const tobaccoUseCheckRequiredStates = [
  StateCode.MINNESOTA
];
export const disclaimerMessages = [
  "indportal.tobacco.privacyNotice.heading",
  "indportal.tobacco.disclaimer1",
  "indportal.tobacco.disclaimer2",
  "indportal.tobacco.disclaimer3",
  "indportal.tobacco.disclaimer4"
];